// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1359":"333bcff9","2965":"da3ee1a3","3409":"31d6cfe0","4899":"4c21b185","7767":"da3ee1a3","8473":"4c21b185"}[chunkId] + ".chunk.css";
};